<template>
  <div class="container">
    <div class="vue">
      <el-row>
        <el-col :span="16" :offset="4">
          <div class="breadcrumb padVertical10 flex flexAi-c">
            <span>当前位置：</span>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>服务资讯</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="contant">
            <div class="rightContent">
              <div class="bg" v-for="(row, i) in articleData.list" :key="i">
                <div class="article_list flex" @click="articleClick(row)">
                  <div class="left">
                    <el-image
                      class=" flex flexAi-c flexJc-c"
                      :src="row.thumbnail"
                    ></el-image>
                  </div>
                  <div class="right flex">
                    <h3 class="title">{{ row.name }}</h3>
                    <div class="time FS075">
                      {{ row.createTime | FilterDataTime }}
                    </div>
                    <div class="contant FS075">
                      {{ row.text | getText }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="block flex flexAi-c flexJc-c"
              v-if="articleData.list != null"
            >
              <div class="page flex flexAi-c spanCol">
                <span>共{{ articleData.pages }}页</span>
                <span class="padHorizontal10"
                  >共 {{ articleData.total }}条信息</span
                >
              </div>
              <el-pagination
                background
                :current-page="page"
                :page-size="articleData.pageSize"
                layout="prev, pager, next, jumper"
                :total="articleData.total"
                @current-change="handleCurrentChange"
              ></el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { apiArticleFindAll } from '@/api/backgroundViews'

export default {
  name: '',
  props: [''],
  data() {
    return {
      articleData: '',
      page: 1, // 当前页数
      size: 10
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.ArticleFindAlll()
  },

  methods: {
    // 点击文章
    articleClick(row) {
      this.$router.push({
        path: '/articleDtl',
        query: {
          id: row.id
        }
      })
    },
    // 分页
    handleCurrentChange(e) {
      this.page = e
      this.ArticleFindAlll()
      console.log(`当前页: ${e}`)
    },
    /* 接口 */
    // 查询全部文章
    ArticleFindAlll() {
      apiArticleFindAll({
        page: this.page,
        size: this.size
      }).then(res => {
        if (res.status === '0') {
          this.articleData = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.vue {
  .contant {
    .rightContent {
      .bg {
        background-color: #f2f2f2;
        margin-bottom: 10px;
      }
      .article_list {
        .left {
          width: 300px;
          height: 150px;
          margin: 15px;
          div {
            width: 100%;
            height: 100%;
            background-color: #fff;
          }
          /deep/ img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
          }
        }
        .right {
          text-align: left;
          width: 60%;
          flex-grow: 1;
          flex-direction: column;
          align-items: flex-start;
          .time {
            padding-bottom: 6px;
          }
          .contant {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            color: #8a8687;
          }
        }
      }
    }
    .block {
      padding: 15px 0;
      .page {
        width: 35%;
      }
      .el-pagination {
        width: 65%;
      }
    }
  }
}
</style>
